/**
 * Paleta de color compartida por toda la UI del lobby, coherente con la
 * paleta violeta oscura ya usada en los stubs de escena (F0).
 */

export const PALETTE = {
  bg: 0x1b1030,
  panel: 0x241c3d,
  panel2: 0x2c1f4d,
  panelLight: 0x362a54,
  border: 0x453a70,
  borderLight: 0x6f6394,

  text: 0xf4f0ff,
  textMuted: 0xa99fd1,
  textDim: 0x6f6394,

  accent: 0xffb703,
  accentDark: 0xc98600,
  accentSoft: 0xffd166,

  success: 0x6fcf6f,
  danger: 0xe0524d,

  sky1: 0x6fb7ff,
  sky2: 0xbfe3ff,
  islandGrass: 0x6fcf6f,
  islandGrassDark: 0x3fae4c,
  islandRock: 0x8a6a4a,
  islandRockDark: 0x5c4630,

  coin: 0xffd166,
  gem: 0x6fcfff,

  rarityComun: 0x9aa0b4,
  rarityRaro: 0x3fb2ff,
  rarityEpico: 0xb98aff,
  rarityLegendario: 0xff8a3d,

  locked: 0x352b4d,
} as const;

export const HEX = {
  text: '#f4f0ff',
  textMuted: '#a99fd1',
  textDim: '#6f6394',
  accent: '#ffb703',
  accentSoft: '#ffd166',
  success: '#6fcf6f',
  danger: '#e0524d',
  panel: '#241c3d',
  bg: '#1b1030',
} as const;

const RARITY_HEX: Record<string, number> = {
  comun: PALETTE.rarityComun,
  raro: PALETTE.rarityRaro,
  epico: PALETTE.rarityEpico,
  legendario: PALETTE.rarityLegendario,
};

/** Color de borde/acento según la rareza (string libre, cae en gris si no matchea). */
export function rarityColor(rarity: string): number {
  return RARITY_HEX[rarity] ?? PALETTE.rarityComun;
}

const SLOT_HEX: Record<string, number> = {
  weapon: 0xe0524d,
  ring: 0xffd166,
  helm: 0x6fb7ff,
  chest: 0x9aa832,
  gloves: 0xc9a227,
  boots: 0x8b5cf6,
};

/** Color de acento por slot de gear, para distinguir de un vistazo en la grilla. */
export function slotColor(slot: string): number {
  return SLOT_HEX[slot] ?? PALETTE.textDim;
}

const SLOT_LABEL: Record<string, string> = {
  weapon: 'Arma',
  ring: 'Anillo',
  helm: 'Casco',
  chest: 'Pecho',
  gloves: 'Guantes',
  boots: 'Botas',
};

/** Nombre corto en español del slot, para etiquetas de UI. */
export function slotLabel(slot: string): string {
  return SLOT_LABEL[slot] ?? slot;
}
